import type { TabScopeParams } from 'models';

const supportedScopeTypes = {
  'change-password': 1,
  'dexcom-sync': 1,
  language: 1,
  notifications: 1,
  passkeys: 1,
  'remove-account': 1,
};
export type SettingsScope = keyof typeof supportedScopeTypes;

export const isSettingsScope = (value?: unknown): value is SettingsScope =>
  typeof value === 'string' ? value in supportedScopeTypes : false;

export type SettingsParams = TabScopeParams<SettingsScope>;
